import * as React from "react";

import { Flex } from "@/shared-web.ui/ui.flex";
import { cn } from "@/shared-web.ui/util.cn";

import * as Prm from "./category-selector.prim";

type CategoryData = Prm.CategoryData;

interface CategorySelectorProps
  extends Omit<
    React.ComponentPropsWithoutRef<typeof Prm.CategorySelectorRoot>,
    "children"
  > {
  className?: string;
}
const CategorySelector = (props: CategorySelectorProps) => {
  const { className, data, moduleType } = props;

  return (
    <Prm.CategorySelectorRoot data={data} moduleType={moduleType}>
      <Flex className={cn("size-full", className)} direction="column">
        <Prm.MainCategoryContainer>
          {data.map((c) => {
            return (
              <Prm.MainCategoryTab key={c.slug} label={c.label} slug={c.slug} />
            );
          })}
        </Prm.MainCategoryContainer>
        <Flex direction="row" flexGrow="1">
          <Prm.SubCategoryColumn />
          <Prm.CategoryLinkGrid />
        </Flex>
      </Flex>
    </Prm.CategorySelectorRoot>
  );
};

export { type CategoryData, CategorySelector };
